import store from '@/vuex/store';

const trataToken = token => {
  const tokenData = token.split('.');
  const decoded = atob(tokenData[1]);
  const tokenJson = JSON.parse(decoded);

  return tokenJson;
};

const obtemPrimeiroNome = nomeCompleto => {
  if (nomeCompleto) {
    const arrayNome = nomeCompleto.split(' ');
    const primeiroNome = arrayNome[0].toLowerCase();
    const primeiraLetraMaiuscula =
      primeiroNome.charAt(0).toUpperCase() + primeiroNome.slice(1);

    return primeiraLetraMaiuscula;
  }
  return '';
};

const obtemUsuarioLogado = token => {
  const usuarioLogado = {};
  const { sub, fullname, roles } = trataToken(token);

  usuarioLogado.sshd = sub;
  usuarioLogado.nome = fullname;
  usuarioLogado.perfis = roles;
  usuarioLogado.primeiroNome = obtemPrimeiroNome(fullname);
  store.commit('setUsuarioLogado', usuarioLogado);
};

export default obtemUsuarioLogado;



// WEBPACK FOOTER //
// ./src/pages/login/obtemUsuarioLogado.js